import {
  ArrowsCounterClockwiseIcon,
  ClipboardTextIcon,
  CoinIcon,
  EnvelopeSimpleIcon,
  GavelIcon,
  GearIcon,
  PaintBrushBroadIcon,
  PlugsIcon,
  ReceiptIcon,
  SparkleIcon,
  StorefrontIcon,
  TruckIcon,
  UserCircleIcon,
} from '@phosphor-icons/react'

export const categories = {
  pages: 'pages',
  shipments: 'shipments',
  returns: 'returns',
  settings: 'settings',
}

export const categoryLabels = {
  [categories.pages]: 'Páginas',
  [categories.shipments]: 'Envíos',
  [categories.returns]: 'Devoluciones',
  [categories.settings]: 'Ajustes',
}

export const debounceMs = 300

export const pageSize = 5

export const settingsMap = [
  { translationKey: 'Tienda', path: '/config/store', Icon: StorefrontIcon },
  { translationKey: 'Política de devoluciones', path: '/config/return-policy', Icon: GavelIcon },
  { translationKey: 'Reembolsos', path: '/config/refunds', Icon: CoinIcon },
  { translationKey: 'Logística', path: '/config/logistics/general', Icon: TruckIcon },
  { translationKey: 'Métodos envío', path: '/config/logistics/shipping-methods', Icon: TruckIcon },
  { translationKey: 'Métodos devolución', path: '/config/logistics/delivery-methods', Icon: TruckIcon },
  { translationKey: 'Ubicaciones', path: '/config/logistics/locations', Icon: TruckIcon },
  { translationKey: 'Motivos devolución', path: '/config/return-reasons', Icon: ArrowsCounterClockwiseIcon },
  { translationKey: 'Inventario', path: '/config/inventory', Icon: ClipboardTextIcon },
  { translationKey: 'Branding', path: '/config/branding', Icon: PaintBrushBroadIcon },
  { translationKey: 'Portal devoluciones', path: '/config/returns-portal', Icon: GearIcon },
  { translationKey: 'Comunicaciones', path: '/config/communications', Icon: EnvelopeSimpleIcon },
  { translationKey: 'Plantillas de correo', path: '/config/email-templates', Icon: EnvelopeSimpleIcon },
  { translationKey: 'Estilos', path: '/config/themes', Icon: EnvelopeSimpleIcon },
  { translationKey: 'Facturación', path: '/config/billing', Icon: ReceiptIcon },
  { translationKey: 'Integraciones', path: '/config/integrations', Icon: PlugsIcon },
  { translationKey: 'Usuarios', path: '/config/users', Icon: UserCircleIcon },
  { translationKey: 'Widgets', path: '/config/extras/reveni-widget', Icon: SparkleIcon },
]
